import { createMiddleware } from '@shared/redux';
import { push } from 'connected-react-router';
import { getUserConfigData } from '@domain/user-config';
import { REDIRECT_OR_OPEN_ONBOARDING_MODAL, openIntegrationsOnboardingModal } from './integrations-onboarding-modal.state';
import { PLATFORMS_FULFILLMENT } from './integrations-onboarding-modal.constants';

export const integrationsOnboardingModalMiddleware = createMiddleware({
    [REDIRECT_OR_OPEN_ONBOARDING_MODAL]: (state, action) => {
        const { platform } = action.payload;
        const userConfig = getUserConfigData(state);
        const hasPartnership = userConfig.PARTNERSHIPS?.ONBOARDING_MODAL?.[platform];

        if (hasPartnership) {
            return push(PLATFORMS_FULFILLMENT[platform]?.route);
        }

        return openIntegrationsOnboardingModal();
    },
});
